export default __webpack_public_path__ + "static/media/GLOSA.fb1bba6b.pdf";